import React, { useContext } from 'react'
import { UserContext } from './Main';
import '../css/home.css'
import vishwa from '../images/vishwa.jpg'
import mahaveer from '../images/MyPicture.jpg'
import pradeep from '../images/pradeep.jpg'
import aashath from '../images/aashath.jpg'
import nagappan from '../images/nagappan.jpg'
import UserCard from '../components/UserCard';
import DevCard from '../components/DevCard';

export default function Home() {

    const value=useContext(UserContext)

    console.log(value);

    return (
        <div className='home'>
            <div className="front">
                <div className="l-front">
                    <div className="l-front-content">
                        <p className='event-name'>Coders Assemble'24</p>
                        <p className='clg-name'>Panimalar Engineering College</p>
                        <span>"Build Your Network By Showcasing Your Skills"</span>
                    </div>
                </div>
                <div className="r-front">
                    <div className="logo">
                        &lt;/&gt;
                    </div>
                </div>
            </div>

            <div className="home-section developers">
                <div className="devs-title"><p><span className='pink'>&#47;&#47;</span>Developer</p></div>
                <div className="member-cards dev-dev">
                    <DevCard
                        name='Mahaveer'
                        img={mahaveer} 
                        phone='1234567890'
                        github='https://github.com/Mahaveer1013?tab=repositories'
                        linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                        gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                        portfolio='https://mahaveer-my-portfolio.netlify.app'
                    />
                </div>
                <div className="member-cards dev-user">
                    <UserCard
                        name='Mahaveer'
                        img={mahaveer} 
                        github='https://github.com/Mahaveer1013?tab=repositories'
                        phone='1234567890'
                        linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                        gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                        portfolio='https://mahaveer-my-portfolio.netlify.app'
                    />
                </div>
            </div> 

            <div className="home-section co-ordinators">
                <div className="devs-title"><p><span className='pink'>&#47;&#47;</span>Co-Ordinators</p></div>
                <div className="member-cards">
                    <UserCard
                        name='Aashath'
                        img={aashath} 
                        github='https://github.com/Mahaveer1013?tab=repositories'
                        phone='1234567890'
                        linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                        gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                        portfolio='https://mahaveer-my-portfolio.netlify.app'
                    />
                    <UserCard
                        name='Nagappan'
                        img={nagappan} 
                        github='https://github.com/Mahaveer1013?tab=repositories'
                        phone='1234567890'
                        linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                        gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                        portfolio='https://mahaveer-my-portfolio.netlify.app'
                    />
                    <UserCard
                        name='Mahaveer'
                        img={mahaveer} 
                        github='https://github.com/Mahaveer1013?tab=repositories'
                        phone='1234567890'
                        linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                        gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                        portfolio='https://mahaveer-my-portfolio.netlify.app'
                    />
                    <UserCard
                        name='Vishwanathan'
                        img={vishwa} 
                        github='https://github.com/Mahaveer1013?tab=repositories'
                        phone='1234567890'
                        linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                        gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                        portfolio='https://mahaveer-my-portfolio.netlify.app'
                    />
                    <UserCard
                        name='Pradeep Krishna'
                        img={pradeep} 
                        github='https://github.com/Mahaveer1013?tab=repositories'
                        phone='1234567890'
                        linkedIn='https://www.linkedin.com/in/mahaveer1013/'
                        gmail={'https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent('a.mahaveer5@gmail.com')}
                        portfolio='https://mahaveer-my-portfolio.netlify.app'
                    />
                </div>
            </div>
        </div>
    )
}